// Quotation Rejected Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationRejectedBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationRejectedStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationRejectedBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationRejectedStage.js